import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { AdminProvider } from "@/context/AdminContext";
import CartDrawer from "@/components/CartDrawer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import StorePage from "@/pages/StorePage";
import CheckoutPage from "@/pages/CheckoutPage";
import TrackPage from "@/pages/TrackPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/store/:storeId" element={<StorePage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/track/:orderId" element={<TrackPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <CartDrawer />}
      {!isAdmin && <ChatWidget />}
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <AdminProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </AdminProvider>
      </AppProvider>
    </div>
  );
}

export default App;
